
    import React, { Fragment } from 'react';
    
    
    const Markdown = () => (<Fragment><h1 id="2133">2.13.3</h1>
<p><em><strong>Released</strong>: May 16th, 2025</em></p>
<h2 id="bug-fix">Bug Fix</h2>
<ul>
<li>Fixed an issue where documents without a name would cause the player to crash</li>
</ul>
<hr/>
<h1 id="v2130">v2.13.0</h1>
<p><em><strong>Released</strong>: April 19th, 2025</em></p>
<h3 id="feature">Feature</h3>
<ul>
<li>Added support for users who could not connect to our realtime Live-Update services &#40;Websockets&#41;</li>
</ul>
<h3 id="bug-fixes">Bug fixes</h3>
<ul>
<li>Fixed an issue with analytics for Persistent &#40;24x7&#41; streams</li>
<li>Fixed an issue where the &quot;Disconnected&quot; notice for 24x7 streams wasn&#39;t displaying correctly when none was assigned through the Default Player Preference</li>
</ul>
<h1 id="v2120">v2.12.0</h1>
<p><em><strong>Released</strong>: March 14th, 2025</em></p>
<h3 id="feature-1">Feature</h3>
<ul>
<li>Added a new feature for supporting &quot;Offline&quot; interstitials/slates for 24x7 Persistent Streams<ul>
<li>By design these inherit your slates assigned to your &quot;Default Preference&quot;, found in your <a href="/manage/player">Player Settings</a> page</li>
<li>Slate types Suppported:<ul>
<li>Videos &#40;multiple&#41; which will play in a loop</li>
<li>A single image</li>
</ul>
</li>
<li>If no Default Preference is present or if your Default preference has no slates assigned, a fallback image slate is provided</li>
</ul>
</li>
</ul>
<hr/>
<h1 id="v2112">v2.11.2</h1>
<p><em><strong>Released</strong>: February 8th, 2025</em></p>
<h3 id="feature-2">Feature</h3>
<ul>
<li>Account for the new preference option: &quot;List Audio Files in Documents Tab&quot; and list all MP3 files when option is toggled on.<ul>
<li>Preference is Toggled Off by default</li>
</ul>
</li>
</ul>
<hr/>
<h1 id="v2111">v2.11.1</h1>
<p><em><strong>Released</strong>: January 31st, 2025</em></p>
<h3 id="bug-fixes-1">Bug Fixes</h3>
<ul>
<li>Fixed an issue where 24/7 Streams wouldn&#39;t be playable in Safari on iOS or macOS</li>
</ul>
<hr/>
<h1 id="v2110">v2.11.0</h1>
<p><em><strong>Released</strong>: January 14th, 2025</em></p>
<h3 id="bug-fixes-2">Bug Fixes</h3>
<ul>
<li>Background performance improvements to help alleviate API load</li>
</ul>
<hr/>
<h1 id="v2102">v2.10.2</h1>
<p><em><strong>Released</strong>: May 15th, 2024</em></p>
<h3 id="bug-fixes-3">Bug Fixes</h3>
<ul>
<li>Fixed an issue with Downloading very old archived media</li>
<li>Fixed an issue where the Slate player would overflow its boundaries when Events went to On Break</li>
<li>Fixed an issue where iOS mobile devices wouldn&#39;t be able to play media</li>
</ul>
<hr/>
<h1 id="v2911">v2.9.11</h1>
<p><em><strong>Released</strong>: April 15th, 2024</em></p>
<h3 id="bug-fix-1">Bug Fix</h3>
<ul>
<li>Fixed an issue with Captions not being listed as available in the player when they were</li>
</ul>
<hr/>
<h1 id="v297">v2.9.7</h1>
<p><em><strong>Released</strong>: April 4th, 2024</em></p>
<h3 id="refactor">Refactor</h3>
<ul>
<li>Updated the URL of where Video and Audio downloads were resolving</li>
</ul>
<hr/>
<h1 id="v296">v2.9.6</h1>
<p><em><strong>Released</strong>: March 13th, 2024</em></p>
<h3 id="quality-of-life">Quality of Life</h3>
<ul>
<li>Updated our methodology for Persistent Stream GeoFencing</li>
</ul>
<hr/>
<h1 id="v295">v2.9.5</h1>
<p><em><strong>Released</strong>: February 23rd, 2024</em></p>
<h3 id="quality-of-life-1">Quality of Life</h3>
<ul>
<li>Updated our media player to its latest release and updated its confiruation to better handle P2P/Peer traffic.</li>
</ul>
<hr/>
<h1 id="v293">v2.9.3</h1>
<p><em><strong>Released</strong>: January 5th, 2024</em></p>
<h3 id="bug-fixes-4">Bug Fixes</h3>
<ul>
<li>Fixed an issue causing the Closed Caption button to be hidden when captions were available.</li>
</ul>
<h3 id="other-notes">Other Notes</h3>
<ul>
<li>Happy New Year!</li>
</ul>
<hr/>
<h1 id="v292">v2.9.2</h1>
<p><em><strong>Released</strong>: November 27th, 2023</em></p>
<h3 id="bug-fixes-5">Bug Fixes</h3>
<ul>
<li>Fixed an issue causing various archived media to get stuck in a buffer loop</li>
</ul>
<hr/>
<h1 id="v290">v2.9.0</h1>
<p><em><strong>Released</strong>: October 31st, 2023</em></p>
<h3 id="minor-release">Minor Release</h3>
<ul>
<li>Updates to enhance how the player handles multiple bitrate profiles for Live streams</li>
</ul>
<hr/>
<h1 id="v283">v2.8.3</h1>
<p><em><strong>Released</strong>: July 28th, 2023</em></p>
<h3 id="refactor-1">Refactor</h3>
<ul>
<li>Updated how we fetch Stream URIs to prepare for upcoming changes to our Backend services.</li>
</ul>
<hr/>
<h1 id="v282">v2.8.2</h1>
<p><em><strong>Released</strong>: July 21st, 2023</em></p>
<h3 id="bug-fixes-6">Bug Fixes</h3>
<ul>
<li>Patched an issue regarding analytics with 24x7/persistent streams.</li>
</ul>
<hr/>
<h1 id="v281">v2.8.1</h1>
<p><em><strong>Released</strong>: June 16th, 2023</em></p>
<h3 id="bug-fixes-7">Bug Fixes</h3>
<ul>
<li><strong>Video Slates Looping</strong>: Fixed an issue where Video Slates would not loop when the Event was in the &#39;new&#39; event status.</li>
</ul>
<hr/>
<h1 id="v280">v2.8.0</h1>
<p><em><strong>Released</strong>: June 9th, 2023</em></p>
<h3 id="features">Features</h3>
<ul>
<li><strong>Transcript Download</strong>: The <code>Transcript</code> tab now includes a <code>Download Transcript</code> button, allowing users to download a text file of the current transcript.</li>
</ul>
<hr/>
<h1 id="v277">v2.7.7</h1>
<p><em><strong>Released</strong>: June 1st, 2023</em></p>
<h3 id="bug-fixes-8">Bug Fixes</h3>
<ul>
<li>Updated the user metrics reporting to ensure they would not be sent while Events are &quot;On Break&quot;</li>
</ul>
<hr/>
<h1 id="v276">v2.7.6</h1>
<p><em><strong>Released</strong>: May 19th, 2023</em></p>
<h3 id="hotfix">Hotfix</h3>
<ul>
<li>Removed the html &quot;title&quot; element from Players so the EventID doesn&#39;t show up when hovered over with the cursor.</li>
</ul>
<hr/>
<h1 id="v275">v2.7.5</h1>
<p><em><strong>Released</strong>: May 2nd, 2023</em></p>
<h3 id="hotfix-1">Hotfix</h3>
<ul>
<li>Changes made to improve peering and playback performance for Persistent/24x7 streams</li>
</ul>
<hr/>
<h1 id="v274">v2.7.4</h1>
<p><em><strong>Released</strong>: April 19th, 2023</em></p>
<h3 id="bug-fixes-9">Bug Fixes</h3>
<ul>
<li>Patched a bug addressing analytics tracking for 24/7 Streams</li>
</ul>
<hr/>
<h1 id="v273">v2.7.3</h1>
<p><em><strong>Released</strong>: April 7th, 2023</em></p>
<h3 id="bug-fixes-10">Bug Fixes</h3>
<ul>
<li>Released a service update which addressed an issue causing Captions to display incorrectly for lower-bitrate media profiles within the Player.</li>
<li>Made adjustments to how the player was being unset after a Live Stream ended.</li>
</ul>
<hr/>
<h1 id="v272">v2.7.2</h1>
<p><em><strong>Released</strong>: March 10th, 2023</em></p>
<h3 id="bug-fixes-11">Bug Fixes</h3>
<ul>
<li>Fixed an issue where live viewers were being shown after a Live Stream had ended</li>
</ul>
<hr/>
<h1 id="v271">v2.7.1</h1>
<p><em><strong>Released</strong>: February 3rd, 2023</em></p>
<h3 id="bug-fixes-12">Bug Fixes</h3>
<ul>
<li>Addressed an issue which caused current runtime and total duration to be misrepresented in Published/VOD media.</li>
</ul>
<hr/>
<h1 id="v270">v2.7.0</h1>
<p><em><strong>Released</strong>: January 26th, 2023</em></p>
<h3 id="features-1">Features</h3>
<ul>
<li><strong>Auto Quality Option</strong>: automatically select video quality based on a user&#39;s bandwidth and available quality options</li>
</ul>
<hr/>
<h1 id="v261">v2.6.1</h1>
<p><em><strong>Released</strong>: January 13th, 2023</em></p>
<h3 id="bug-fixes-13">Bug Fixes</h3>
<ul>
<li>Fixed an issue where the media player&#39;s initial overlay Play button would overflow the boundary of the Video Player</li>
</ul>
<hr/>
<h1 id="v260">v2.6.0</h1>
<p><em><strong>Released</strong>: December 9th, 2022</em></p>
<h3 id="features-2">Features</h3>
<ul>
<li>Latest version of p2p streaming</li>
</ul>
<hr/>
<h1 id="v254">v2.5.4</h1>
<p><em><strong>Released</strong>: November 18th, 2022</em></p>
<h3 id="bug-fixes-14">Bug Fixes</h3>
<ul>
<li>Player would continue to show the On Break slate after going back to Live from a Break</li>
</ul>
<hr/>
<h1 id="v253">v2.5.3</h1>
<p><em><strong>Released</strong>: November 8th, 2022</em></p>
<h3 id="bug-fixes-15">Bug Fixes</h3>
<ul>
<li>Addressed an issue where Audio would continue playing when the stream went &#39;on break&#39; in the Safari web browser</li>
</ul>
<hr/>
<h1 id="v251">v2.5.1</h1>
<p><em><strong>Released</strong>: September 16th, 2022</em></p>
<h3 id="bug-fixes-16">Bug Fixes</h3>
<ul>
<li>Addressed an issue where Video Slates would no longer play while Event was in an Offline state</li>
<li>Added Analytics/Metric Tracking to the Video and Audio Download buttons</li>
</ul>
<hr/>
<h1 id="v250">v2.5.0</h1>
<p><em><strong>Released</strong>: September 10th, 2022</em></p>
<h3 id="features-3">Features</h3>
<p><strong>Break Override:</strong></p>
<ul>
<li>When set in the Control Center, the Break Override will ensure the Media Player remains visible and playing when the Event is Paused.</li>
</ul>
<hr/>
<h1 id="v2393">v2.3.93</h1>
<p><em><strong>Released</strong>: August 12th, 2022</em></p>
<h3 id="bug-fixes-17">Bug Fixes</h3>
<ul>
<li>Applied a patch to address two analytics issues:<ul>
<li>Incorrect Event Titles &#40;some were being reported as &quot;Unknown&quot;&#41;</li>
<li>Incorrect Stream states</li>
</ul>
</li>
<li>Applied a patch to address issues related to displaying and updating the Current Item for Live Streams</li>
</ul>
<hr/>
<h1 id="v2392">v2.3.92</h1>
<p><em><strong>Released</strong>: June 28th, 2022</em></p>
<h3 id="bug-fixes-18">Bug Fixes</h3>
<ul>
<li>Applied a patch from our Vendor System73 to handle issues with Fullscreen issues across various devices<ul>
<li>Does not include Tizen/Samsung SmartTV browsers</li>
</ul>
</li>
</ul>
</Fragment>);
    export default Markdown;
  